<template>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlStart-->

  <div id="defaultId1">
    <div id="g02c78" class="ua36c6">
      <div id="g4579f" class="uPdtqFl">
        <!-- 左侧Address -->
        <div id="g19d21" class="ud85c3">
          <div
            id="gb6cd5"
            class="u9916e"
            v-if="companyBase?.base?.companyName != '-'"
          >
            <div id="ge86b0" class="u4b926">
              <svg
                t="1760168217330"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="7886"
                width="24px"
                height="24px"
              >
                <path
                  d="M886.968 959.426V116.173L753.628 0 309.895 165.776v41.52L712.908 71.46v948.847h268.276v-60.88h-94.216zM165.577 699.634l211.287-42.218v-107.19l-211.287 55.491v93.917z m0 322.07h211.287v-112.48l-211.287 15.27v97.21z m0-161.584l211.287-20.36V732.769l-211.287 35.43v91.921z m0-324.067l211.287-58.087V366.584l-211.287 71.46v98.009z"
                  fill="#1A2332"
                  p-id="7887"
                ></path>
                <path
                  d="M611.206 259.194L491.84 186.635 42.717 348.62l-0.3 675.381h59.185V381.255l336.143-110.683v749.935h173.461V259.194z"
                  fill="#1A2332"
                  p-id="7888"
                ></path>
              </svg>

              <span id="g7f99a" class="u3eb5e">{{
                $t("Snapshot.CoName")
              }}</span>
            </div>
            <p id="g95852" class="u61a08">
              {{ companyBase?.base?.companyName }}
            </p>
          </div>
          <div
            id="gb6cd5"
            class="u9916e"
            v-if="companyBase?.base?.address != '-'"
          >
            <div id="ge86b0" class="u4b926">
              <svg
                id="idIfp3xN"
                class="icon"
                t="1718249996234"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4358"
                width="24px"
                height="28px"
              >
                <path
                  id="idJr6ooL"
                  d="M524.245333 866.176a21.333333 21.333333 0 0 1-24.490666 0C308.821333 732.373333 213.333333 600.106667 213.333333 469.333333c0-200.298667 149.333333-298.666667 298.666667-298.666666s298.666667 98.368 298.666667 298.666666c0 130.773333-95.466667 263.04-286.421334 396.842667zM512 576a128 128 0 1 0 0-256 128 128 0 0 0 0 256z"
                  fill="#1A2332"
                  p-id="4359"
                ></path>
              </svg>
              <span id="g7f99a" class="u3eb5e"
                >{{ $t("Snapshot.Address") }}
              </span>
            </div>
            <p id="g95852" class="u61a08">{{ companyBase?.base?.address }}</p>
          </div>
          <div
            id="cbb2f4"
            class="u9916e"
            v-if="
              companyBase?.base?.durant != '-' || companyBase?.base?.city != '-'
            "
          >
            <div id="c615d3" class="u4b926">
              <svg
                id="idpphnWt"
                class="icon"
                t="1718254943845"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4636"
                width="18px"
                height="26px"
              >
                <path
                  id="id1ZPDUz"
                  d="M557.728 688v288.384H466.24V688H227.52c-9.6 0-18.048-3.712-24.96-11.264A37.824 37.824 0 0 1 192 649.984c0-48.768 14.432-92.704 43.584-131.84 29.12-38.976 61.92-58.56 98.56-58.56V200.512c-19.296 0-35.84-7.552-50.048-22.656a76.16 76.16 0 0 1-21.12-53.6c0-20.672 7.04-38.4 21.12-53.6 13.984-14.976 30.72-22.656 50.048-22.656h355.584c19.296 0 35.84 7.552 50.048 22.656 13.984 15.104 21.152 32.928 21.152 53.6 0 20.672-7.04 38.4-21.12 53.6-14.112 15.232-30.784 22.656-50.08 22.656v258.944c36.64 0 69.568 19.584 98.56 58.56A215.424 215.424 0 0 1 832 649.984c0 10.272-3.456 19.328-10.528 26.752-7.04 7.424-15.36 11.264-24.96 11.264H557.76z"
                  fill="#1A2332"
                  p-id="4637"
                ></path>
              </svg>
              <span id="c7de49" class="u3eb5e">{{
                $t("Snapshot.CountyCity")
              }}</span>
            </div>
            <p id="c9f4f7" class="u61a08">
              <span v-if="companyBase?.base?.durant != '-'">{{
                companyBase?.base?.durant
              }}</span
              ><span
                v-if="
                  companyBase?.base?.city != '-' &&
                  companyBase?.base?.durant != '-'
                "
                >&nbsp;,&nbsp;</span
              ><span v-if="companyBase?.base?.city != '-'">{{
                companyBase?.base?.city
              }}</span>
            </p>
          </div>

          <div
            id="ca51a0"
            class="u9916e"
            v-if="companyBase?.base?.province != '-'"
          >
            <div id="ca64a8" class="u4b926">
              <svg
                id="idKLJKep"
                class="icon"
                t="1718257782897"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4998"
                width="24px"
                height="24px"
              >
                <path
                  id="idBCVieI"
                  d="M887.466667 910.222222H136.533333c-28.444444 0-51.2 22.755556-51.2 51.2v11.377778c0 28.444444 22.755556 51.2 51.2 51.2h750.933334c28.444444 0 51.2-22.755556 51.2-51.2v-11.377778c0-28.444444-22.755556-51.2-51.2-51.2z m96.711111-489.244444L548.977778 14.222222c-19.911111-19.911111-51.2-19.911111-73.955556 0L39.822222 420.977778c-19.911111 19.911111-11.377778 42.666667 8.533334 62.577778H113.777778v369.777777h113.777778V483.555556h113.777777v369.777777h113.777778V483.555556h113.777778v369.777777h113.777778V483.555556h113.777777v369.777777h113.777778V483.555556h65.422222c19.911111-19.911111 31.288889-42.666667 8.533334-62.577778zM512 341.333333c-48.355556 0-85.333333-36.977778-85.333333-85.333333s36.977778-85.333333 85.333333-85.333333 85.333333 36.977778 85.333333 85.333333-36.977778 85.333333-85.333333 85.333333z"
                  fill="#1A2332"
                  p-id="4999"
                ></path>
              </svg>
              <span id="cb582d" class="u3eb5e">{{
                $t("Snapshot.ProvinceState")
              }}</span>
            </div>
            <div id="c9a01a" class="u110de">
              <p id="c3cdcf" class="ufde6c">
                {{ companyBase?.base?.province }}
              </p>
            </div>
          </div>
          <div
            id="ca590d"
            class="u9916e"
            v-if="companyBase?.base?.country != '-'"
          >
            <div id="ccbf16" class="u4b926">
              <svg
                id="id6Cu6X9"
                class="icon"
                t="1718257602071"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4819"
                width="24px"
                height="26px"
              >
                <path
                  id="idWdx84H"
                  d="M838.144 187.392c0-22.528-21.504-16.896-28.16-10.24-12.8 13.824-46.592 41.984-118.784 56.832-11.264 2.56-22.016 3.584-33.28 3.584-34.816 0-64-11.264-97.28-24.576-38.4-14.848-81.92-31.744-141.312-31.744-5.12 0-10.24 0-15.36 0.512-64.512 3.072-120.32 31.232-160.768 52.224a1641.853 1641.853 0 0 1-35.84 17.408l-3.584-8.704-0.512-0.512c-5.632-13.312-20.992-19.456-34.304-13.824-6.144 2.56-11.264 7.68-13.824 14.336-2.56 6.144-2.56 13.824 0 19.968l266.752 631.808c4.096 9.728 13.312 15.872 24.064 15.872 3.584 0 7.168-0.512 10.24-2.048 13.312-5.632 19.456-20.992 13.824-34.304L378.88 657.92c11.776-19.456 37.888-52.224 88.064-66.048 15.872-4.096 32.256-6.656 50.176-6.656 34.304 0 67.584 7.68 102.912 15.872 32.256 7.168 65.024 14.848 97.28 14.848 48.64 0 86.016-16.896 118.272-52.736 1.024-1.536 2.048-5.12 2.56-8.192V187.392z"
                  fill="#1A2332"
                  p-id="4820"
                ></path>
              </svg>
              <span id="c2a54a" class="u3eb5e">{{
                $t("Snapshot.CountryRegion")
              }}</span>
            </div>
            <div id="g2f1ca" class="u110de">
              <div id="g5ca90" class="u40641">
                <img
                  id="gf2e43"
                  class="uc6a2b"
                  :src="companyBase?.base?.img"
                  alt=""
                />
              </div>
              <p id="c3cdcf" class="ufde6c">{{ companyBase?.base?.country }}</p>
            </div>
          </div>
          <div
            id="c1a785"
            class="u9916e"
            v-if="companyBase?.base?.postCode != '-'"
          >
            <div id="c4bbbd" class="u4b926">
              <svg
                id="idiPNkIL"
                class="icon"
                t="1718258027119"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5177"
                width="24px"
                height="28px"
              >
                <path
                  id="idEbfpIr"
                  d="M853.333333 290.759111V158.037333C762.311111 131.015111 607.402667 116.053333 512 113.777778c-95.459556 2.218667-250.311111 17.066667-341.333333 44.259555V290.702222h93.696v530.944H170.666667V910.222222h682.666666v-88.519111h-93.696V290.759111H853.333333z m-468.48 44.259556h254.293334v44.259555h-254.293334v-44.259555z m269.994667 357.148444c0 26.168889-21.219556 47.388444-47.388444 47.388445H415.004444a47.388444 47.388444 0 0 1-47.445333-47.388445V502.499556c0-26.168889 21.219556-47.388444 47.445333-47.388445h192.455112c26.168889 0 47.388444 21.219556 47.388444 47.388445v189.667555zM515.584 560.526222a42.496 42.496 0 0 1 10.126222-48.184889 48.924444 48.924444 0 0 1 51.086222-9.614222c17.464889 6.826667 28.899556 22.983111 28.899556 40.903111 0 24.462222-20.992 44.202667-46.819556 44.202667a46.933333 46.933333 0 0 1-43.292444-27.306667z"
                  fill="#1A2332"
                  p-id="5178"
                ></path>
              </svg>
              <span id="cd1e9b" class="u3eb5e"
                >{{ $t("Snapshot.ZipCode") }}
              </span>
            </div>
            <p id="c3d6f8" class="u61a08">{{ companyBase?.base?.postCode }}</p>
          </div>
        </div>
        <div id="c30c2c" class="ud85c3">
          <div
            id="c4947f"
            class="u9916e"
            v-if="companyBase?.base?.companyNameNative != '-'"
          >
            <div id="ce571a" class="u4b926">
              <svg
                t="1760168391629"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="7886"
                width="28px"
                height="28px"
              >
                <path
                  d="M616.64 408.896h89.152v40.128H616.64z"
                  fill="#1A2332"
                  p-id="7887"
                ></path>
                <path
                  d="M797.632 192H226.368c-68.608 0-124.48 58.624-124.48 130.688v378.624c0 72.064 55.872 130.688 124.48 130.688h571.264c68.608 0 124.48-58.624 124.48-130.688V322.688c0-72.064-55.872-130.688-124.48-130.688zM284.288 489.088l158.72 0.192a33.984 33.984 0 0 1 0 67.968l-158.72-0.192a33.984 33.984 0 0 1 0-67.968z m221.568 194.048l-221.568-0.256a33.984 33.984 0 0 1 0-67.904l221.568 0.064a34.048 34.048 0 0 1 0 68.096z m267.84-217.472a51.52 51.52 0 0 1-51.328 51.328H600a51.584 51.584 0 0 1-51.328-51.328V392.256a51.52 51.52 0 0 1 51.328-51.328h122.368a51.584 51.584 0 0 1 51.328 51.328v73.408z"
                  fill="#1A2332"
                  p-id="7888"
                ></path>
              </svg>
              <span id="c1f5d8" class="u3eb5e uc879f"
                >{{ $t("Snapshot.RegName") }}
              </span>
            </div>
            <p id="cd7a3e" class="u61a08">
              {{ companyBase?.base?.companyNameNative }}
            </p>
          </div>
          <div
            id="c712f3"
            class="u9916e"
            v-if="companyBase?.base?.website.split(';').length > 0"
          >
            <div id="c763c1" class="u4b926">
              <svg
                id="id8gOwtv"
                class="icon"
                t="1718261775785"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5356"
                width="24px"
                height="24px"
              >
                <path
                  id="idhZtOPW"
                  d="M752.774325 256.240941c34.093176-4.156235 157.635765-67.945412 157.635764-67.945412C1027.146089 342.016 1024.013854 491.580235 1024.013854 491.580235h-244.916706c9.396706-93.063529-26.322824-235.339294-26.322823-235.339294zM633.207266 16.203294c67.764706-7.830588 249.072941 129.204706 238.652235 138.601412-10.420706 9.396706-132.336941 52.284235-132.336941 52.284235-24.997647-115.049412-106.315294-190.885647-106.315294-190.885647zM535.264678 244.736V0c106.315294 41.863529 160.466824 221.726118 160.466823 221.726118-24.997647 12.589176-160.466824 23.009882-160.466823 23.009882zM329.982795 805.345882l154.202353-23.009882v241.603765c-107.339294-37.647059-154.202353-218.593882-154.202353-218.593883z m-43.971764-268.769882h198.174117v201.848471s-137.517176 7.348706-168.779294 23.009882c0 0-36.924235-142.215529-29.394823-224.858353z m28.310588-266.721882c38.610824 19.877647 169.863529 16.745412 169.863529 16.745411v204.980706H287.275972c-8.372706-71.137882 27.045647-221.726118 27.045647-221.726117zM484.185148 0v244.736l-159.382588-25.118118S373.773854 46.019765 484.185148 0zM281.011501 207.088941L147.590325 152.696471C287.275972 25.118118 426.901384 2.108235 385.21856 23.009882c-41.682824 20.901647-104.207059 184.079059-104.207059 184.079059z m-37.526588 280.274824H0.013854c0-136.372706 114.266353-299.068235 114.266353-299.068236 29.153882 29.274353 156.310588 69.029647 156.310588 69.029647-27.105882 56.440471-27.105882 230.038588-27.105882 230.038589z m27.105882 287.683764c-51.079529 5.240471-155.286588 65.897412-155.286588 65.897412C11.097148 730.051765 0.013854 536.576 0.013854 536.576h240.338824c-3.312941 66.921412 30.238118 238.471529 30.238117 238.471529z m114.025412 238.47153c-124.626824-25.118118-240.097882-140.167529-240.097882-140.16753l140.468706-55.41647c11.264 86.799059 99.629176 195.584 99.629176 195.584zM705.128207 269.854118c15.661176 26.142118 30.238118 221.726118 30.238118 221.726117H535.264678V288.707765c66.680471 11.504941 169.863529-18.853647 169.863529-18.853647z m2.108235 491.580235c-111.495529-27.226353-171.971765-18.853647-171.971764-18.853647v-206.004706h200.101647c2.228706 72.402824-28.129882 224.858353-28.129883 224.858353z m-171.971764 262.505412v-241.603765c38.550588 0 156.310588 23.009882 156.310588 23.009882-45.839059 189.319529-156.310588 218.593882-156.310588 218.593883z m200.222117-212.269177l138.480941 64.813177c-106.315294 124.446118-238.592 131.794824-238.592 131.794823 74.029176-60.656941 100.111059-190.343529 100.111059-190.343529v-6.264471z m43.610353-275.094588H1024.013854c2.108235 180.886588-117.76 303.344941-117.76 303.344941-4.156235-12.589176-153.479529-70.113882-153.479529-70.113882 19.456-14.637176 26.322824-233.231059 26.322823-233.231059z"
                  fill="#1A2332"
                  p-id="5357"
                ></path>
              </svg>
              <span id="cc2504" class="u3eb5e uc879f"
                >{{ $t("Snapshot.Website") }}
              </span>
            </div>
            <span
              id="g3d233"
              class="u4a559"
              style="text-decoration: underline; cursor: pointer"
              v-for="(item, index) in companyBase?.base?.website.split(';')"
              :key="index"
              @click="setid(item)"
            >
              {{ item }}
              <!-- <router-link :to="'http://'+obj.Website">{{ obj.Website }}</router-link> -->
            </span>
          </div>
          <div
            id="cf5c49"
            class="u9916e"
            v-if="companyBase?.base?.email != '-'"
          >
            <div id="c63125" class="u4b926">
              <svg
                id="idP4e46a"
                class="icon"
                t="1718261953119"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5680"
                width="24px"
                height="20px"
              >
                <path
                  id="id5CKPXo"
                  d="M628.992 607.850667c-57.749333 46.272-93.781333 69.226667-129.728 69.226667-34.517333 0-69.376-21.504-123.285333-63.509333L55.082667 895.957333l903.701333 0L632.661333 605.098667C631.466667 605.973333 630.122667 607.061333 628.992 607.850667z"
                  fill="#272636"
                  p-id="5681"
                ></path>
                <path
                  id="idLKu97o"
                  d="M248.405333 514.858667C172.224 456.106667 84.352 388.117333 0 321.429333L0 853.76c0 1.706667 0.810667 3.136 0.981333 4.714667l323.52-284.714667C301.056 555.456 275.904 536.106667 248.405333 514.858667z"
                  fill="#272636"
                  p-id="5682"
                ></path>
                <path
                  id="id17fL8e"
                  d="M1021.482667 866.133333C1022.784 862.272 1024 858.218667 1024 853.76L1024 298.837333c-101.269333 78.762667-247.829333 192.917333-340.394667 265.962667L1021.482667 866.133333z"
                  fill="#272636"
                  p-id="5683"
                ></path>
                <path
                  id="id1v6HBC"
                  d="M960 128.021333 64 128.021333c-23.36 0-64 40.682667-64 64l0 50.432c94.378667 75.136 196.885333 154.218667 283.733333 221.205333 47.893333 36.970667 90.816 70.186667 124.693333 96.64 91.306667 71.616 91.306667 71.616 184.512-2.901333C677.226667 490.026667 904 313.557333 1024 220.224L1024 192.085333C1024 168.64 983.381333 128.021333 960 128.021333z"
                  fill="#272636"
                  p-id="5684"
                ></path>
              </svg>
              <span id="c6fd7a" class="u3eb5e uc879f"
                >{{ $t("Snapshot.Email") }}
              </span>
            </div>
            <a
              id="cd7a3e"
              class="u61a08 u4a559"
              :href="'mailto:' + companyBase?.base?.email"
              >{{ companyBase?.base?.email }}</a
            >
          </div>
          <div id="c4947f" class="u9916e" v-if="companyBase?.base?.tel != '-'">
            <div id="ce571a" class="u4b926">
              <svg
                id="id5TDr5Q"
                class="icon"
                t="1718262310939"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5832"
                width="24px"
                height="24px"
              >
                <path
                  id="id76smaC"
                  d="M280.8832 174.3872c-12.6976 0-25.3952 5.7344-36.9664 17.1008-4.3008 4.1984-9.4208 10.1376-15.4624 17.7152-2.3552 2.9696-4.8128 6.144-7.3728 9.6256-5.5296 7.4752-11.4688 15.7696-17.5104 24.7808-4.1984 6.2464-6.7584 10.1376-7.4752 11.264l-0.4096 0.512c-20.2752 29.696-27.3408 82.5344-15.36 115.4048l0.512 1.3312 0.3072 1.4336c0.3072 1.4336 2.2528 8.0896 5.9392 18.5344 6.0416 17.7152 13.4144 36.2496 21.8112 55.1936 27.0336 60.7232 61.2352 117.1456 101.6832 167.7312 13.0048 16.2816 26.7264 32.0512 40.8576 46.7968 17.408 18.2272 36.352 35.84 56.2176 52.4288 46.6944 38.8096 98.7136 72.192 154.7264 99.0208 17.5104 8.3968 34.6112 15.7696 50.8928 22.016 11.3664 4.3008 17.5104 6.2464 19.1488 6.7584l0.9216 0.3072 0.8192 0.3072c32.4608 12.5952 85.9136 8.192 116.736-9.6256l0.6144-0.3072c2.1504-1.1264 6.7584-3.6864 12.9024-7.168 10.6496-6.0416 20.5824-11.9808 29.4912-17.408 3.4816-2.1504 6.8608-4.3008 9.9328-6.2464 13.6192-8.8064 23.04-15.6672 27.8528-20.5824 23.552-23.7568 23.6544-51.9168 0.3072-75.4688-31.4368-31.6416-62.5664-62.7712-92.672-92.5696-23.1424-22.9376-50.7904-22.9376-73.9328 0-6.5536 6.5536-16.896 16.6912-29.9008 29.7984l-47.4112 47.2064-15.36-6.2464c-5.5296-2.2528-14.848-6.2464-27.8528-12.4928-24.064-11.5712-46.3872-24.2688-66.4576-37.7856-18.8416-12.5952-35.2256-25.7024-48.8448-39.0144-14.9504-14.5408-29.7984-33.4848-44.1344-56.2176-11.8784-18.8416-23.2448-39.8336-33.6896-62.464-5.9392-12.8-9.5232-21.6064-11.1616-25.8048l-6.0416-15.2576 44.032-44.032c15.1552-15.1552 26.2144-26.2144 31.232-31.3344 23.9616-24.064 23.8592-51.712-0.2048-75.9808-20.3776-20.5824-78.336-78.5408-91.8528-91.8528-11.3664-11.6736-24.1664-17.408-36.864-17.408z"
                  p-id="5833"
                ></path>
              </svg>
              <span id="c1f5d8" class="u3eb5e uc879f"
                >{{ $t("Snapshot.Tel") }}
              </span>
            </div>
            <p id="cd7a3e" class="u61a08">{{ companyBase?.base?.tel }}</p>
          </div>
          <div
            id="c78701"
            class="u9916e"
            v-if="companyBase?.base?.lastUpdate != '-'"
          >
            <div id="c1b8a4" class="u4b926">
              <svg
                id="idGnBEiG"
                class="icon"
                t="1718262493202"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5981"
                width="24px"
                height="24px"
              >
                <path
                  id="idaVMSJe"
                  d="M832 544l-1.578667-0.128a320 320 0 0 1-636.842666 0l-1.578667 0.128H140.032a373.333333 373.333333 0 0 0 371.968 341.333333c89.6 0 174.165333-31.573333 241.066667-88.32a32 32 0 1 1 41.386666 48.896A435.626667 435.626667 0 0 1 512 949.333333C270.506667 949.333333 74.666667 753.493333 74.666667 512a32 32 0 0 1 32-32h85.333333l1.578667 0.128a320 320 0 0 1 636.842666 0l1.578667-0.128h51.968a373.333333 373.333333 0 0 0-657.066667-209.024 32 32 0 0 1-48.896-41.301333A436.352 436.352 0 0 1 512 74.666667c237.525333 0 430.805333 189.312 437.162667 425.301333l0.170666 12.032a32 32 0 0 1-27.648 31.701333l-4.352 0.298667h-85.333333zM512 266.666667a32 32 0 0 0-31.701333 27.648L480 298.666667v213.333333c0 16.213333 12.032 29.568 27.648 31.701333l4.352 0.298667h213.333333l4.352-0.298667a32 32 0 0 0 0-63.402666L725.333333 480h-181.333333V298.666667l-0.298667-4.352A32 32 0 0 0 512 266.666667z"
                  fill="#1A2332"
                  p-id="5982"
                ></path>
              </svg>
              <span id="cd5365" class="u3eb5e uc879f"
                >{{ $t("Snapshot.LastUpdate") }}
              </span>
            </div>
            <div id="c9a01a" class="u110de">
              <p id="c3935a" class="ufde6c">
                {{ companyBase?.base?.lastUpdate }}
              </p>
            </div>
          </div>
          <div
            id="c7b0ce"
            class="u9916e"
            v-if="companyBase?.base?.dataSource.length > 0"
          >
            <div id="cd3dc1" class="u4b926">
              <svg
                id="idOesffr"
                class="icon"
                t="1718262576631"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6160"
                width="24px"
                height="24px"
              >
                <path
                  id="idUfbcBs"
                  d="M720.64 180.48L512 60.16 303.36 180.48v240.64L512 542.08l208.64-120.96V180.48zM52.48 602.88v240.64l208.64 120.32 208.64-120.32V602.88L261.12 481.92 52.48 602.88zM762.88 481.92L554.24 602.88v240.64l208.64 120.32 208.64-120.32V602.88l-208.64-120.96z"
                  p-id="6161"
                  fill="#1A2332"
                ></path>
              </svg>
              <span id="cdc5ee" class="u3eb5e uc879f"
                >{{ $t("Snapshot.DataSource") }}
              </span>
            </div>
            <span
              id="g3d233"
              class="u4a559"
              style="text-decoration: underline; cursor: pointer"
              v-for="(item, index) in companyBase?.base?.dataSource"
              :key="index"
              @click="setid(item.website)"
            >
              {{ item.register }}
              <!-- <router-link :to="'http://'+obj.Website">{{ obj.Website }}</router-link> -->
            </span>
          </div>
        </div>
      </div>
      <div id="g9cd74" class="udd14e">
        <rectcard id="g89fbe" v-model="LegalData" class="uvIF6MS">
          <template id="idfVMOhg" slot="icon">
            <svg
              t="1728874194235"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5759"
            >
              <path
                d="M570.61792 79.36L504.79392 14.912a52.8 52.8 0 0 0-73.6 0L215.35392 226.272a50.176 50.176 0 0 0 0 72l65.824 64.448a21.472 21.472 0 0 0 29.888 0l93.536 91.552L10.68192 839.872a35.104 35.104 0 0 0 0 50.4l64.896 63.52a36.96 36.96 0 0 0 51.52 0l393.856-385.6 82.048 80.32a20.384 20.384 0 0 0 0 29.28l65.824 64.416a52.8 52.8 0 0 0 73.6 0l215.872-211.328a50.176 50.176 0 0 0 0-72l-65.824-64.448a21.472 21.472 0 0 0-29.888 0l-1.568 1.536-291.968-285.824 1.6-1.536a20.384 20.384 0 0 0 0-29.248z m120.064 620.704l-21.856-21.408a20.384 20.384 0 0 1 0-29.248l194.656-190.56a21.472 21.472 0 0 1 29.888 0l21.888 21.408a20.384 20.384 0 0 1 0 29.28l-194.688 190.528a21.44 21.44 0 0 1-29.888 0z m-55.2-83.296l-114.528-112.096L127.06592 890.24a36.96 36.96 0 0 1-51.488 0 35.104 35.104 0 0 1 0-50.432l393.92-385.568-125.92-123.2 193.12-189.056 291.84 285.728-193.056 189.024zM258.39392 247.648l194.656-190.56a21.472 21.472 0 0 1 29.888 0l22.784 22.272a20.384 20.384 0 0 1 0 29.28L311.03392 299.2a21.472 21.472 0 0 1-29.888 0l-22.752-22.304a20.384 20.384 0 0 1 0-29.248zM1024.02592 1024H403.89792v-22.464c0-66.976 55.68-121.472 124.096-121.472h371.936c68.416 0 124.096 54.496 124.096 121.472V1024z m-570.784-44.928h521.44a78.176 78.176 0 0 0-74.752-54.08H527.99392c-35.136 0-64.928 22.784-74.752 54.08z"
                fill="#ffffff"
                p-id="5760"
              ></path>
            </svg>
          </template>
          <div
            v-for="(cardItem, index) in LegalData.data"
            :key="index"
            class="uUgMeVl"
          >
            <content_text
              id="idd2uZmx"
              :label="cardItem.label"
              contentAlign="space-between"
              class="label_item"
            >
              <!-- <template slot="icon">
                <div id="g50a77" :style="{ background: LegalData.color }" class="u1ba97"></div>
              </template> -->

              <div id="gfe9e2" class="uAXSGHp" style="text-align: right">
                {{ cardItem.content }}
              </div>
            </content_text>
          </div>
        </rectcard>
        <rectcard
          id="c3c896"
          v-model="CurrentData"
          class="uvIF6MS"
          @houershow="houershow"
        >
          <template slot="icon">
            <svg
              t="1728874256545"
              class="icon secondIcon"
              viewBox="0 0 1092 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6008"
            >
              <path
                d="M931.634579 0.000341c17.749322 0 32.119445 14.33599 32.119445 32.017046v511.965525h96.392469a32.187712 32.187712 0 0 1 32.119445 32.017045v416.01679a31.948779 31.948779 0 0 1-32.119445 31.982912H32.085312A32.187712 32.187712 0 0 1 0 991.982613V576.034091a31.948779 31.948779 0 0 1 32.119445-32.017046h64.238891V159.983168a32.085312 32.085312 0 0 1 32.153578-31.982912l128.477781-0.034133V31.983253A31.948779 31.948779 0 0 1 289.143274 0.000341h642.491305zM415.948523 608.017003H64.238891v351.982698h963.788157V607.982869h-319.52192l-35.498643 106.154596a32.085312 32.085312 0 0 1-30.481047 21.845319H481.962345a32.051179 32.051179 0 0 1-30.481046-21.845319l-35.498643-106.154596zM899.515134 63.966165H321.262719L321.194453 543.982912h117.828188c13.858124 0 26.077849 8.806394 30.446913 21.913585l35.498643 106.08633h114.34659l35.498643-106.08633a32.085312 32.085312 0 0 1 30.446913-21.913585h214.186524V64.000299zM256.989695 192.000213H160.63136v352.016832h96.358335V191.96608z m514.047658 191.999872c17.715188 0 32.085312 14.33599 32.085312 32.017046a32.085312 32.085312 0 0 1-32.085312 31.982912h-321.296853a32.085312 32.085312 0 0 1-32.085312-32.017046 32.085312 32.085312 0 0 1 32.085312-31.982912h321.262719z m0-191.999872c17.715188 0 32.085312 14.33599 32.085312 32.017046a32.085312 32.085312 0 0 1-32.085312 31.982912h-321.296853a32.085312 32.085312 0 0 1-32.085312-32.017046 32.085312 32.085312 0 0 1 32.085312-31.982912h321.262719z"
                fill="#ffffff"
                p-id="6009"
              ></path>
            </svg>
          </template>
          <div
            v-for="(cardItem, index) in CurrentData.data"
            :key="index"
            class="uUgMeVl"
          >
            <content_text
              id="c78ae7"
              :label="cardItem.label"
              contentAlign="space-between"
              class="label_item"
            >
              <!-- <template slot="icon">
                <div id="c675ec" :style="{ background: CurrentData.color }" class="u1ba97"></div>
              </template> -->
              <el-tooltip
                :disabled="cardItem?.content?.length < 20"
                :content="cardItem.content"
                placement="top"
              >
                <!-- <div id="c6ad94" :class="hideshow ? 'uAXSGHpshow' : 'uAXSGHp'">{{ cardItem.content }}</div> -->

                <div
                  id="gfe9e2"
                  :class="hideshow ? 'uAXSGHpshow' : 'uAXSGHp'"
                  style="text-align: right"
                >
                  {{ cardItem.content }}
                </div>
              </el-tooltip>
            </content_text>
          </div>
        </rectcard>
        <rectcard id="cd4fa5" v-model="FinancialData" class="uvIF6MS">
          <template slot="icon">
            <svg
              id="cc998e"
              class="icon u4tpWD5 thirdIcon"
              t="1718353204480"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4853"
            >
              <path
                id="c50b61"
                class="uzTQQ1m"
                d="M450.3 658.7s-5.3-1.1-16-3.4c-10.6-2.3-20.6-5.7-29.8-10.2-9.2-4.5-17.9-10.2-25.9-17l21.6-26.5c9.4 8.2 19.8 14.3 31.1 18.4 11.3 4.1 23.6 6.1 36.9 6.1 17.9 0 31.8-3.3 41.6-9.9 9.9-6.6 14.8-16 14.8-28.1v-0.2c0-8.6-2.2-15.4-6.7-20.5s-10.3-8.8-17.3-11.2c-7.1-2.4-16.2-4.7-27.4-6.7-0.3-0.1-0.7-0.2-1.1-0.2s-0.8 0-1.1-0.2l-2.5-0.5c-16.5-2.8-30-6-40.4-9.6s-19.2-10.1-26.6-19.5c-7.4-9.5-11-22.9-11-40.3v-0.2c0-15.3 3.4-28.3 10.3-39.2s16.8-19.1 30-24.7c13.1-5.7 28.9-8.5 47.4-8.5 8.8 0 17.5 1 26.1 2.9 8.6 1.9 17 4.8 25.3 8.6s16.5 8.6 24.6 14.3l-19.7 27.5c-9.4-6.9-18.8-12.1-28.1-15.5s-18.7-5.2-28.1-5.2c-16.9 0-30 3.4-39.3 10.1-9.3 6.7-14 16.3-14 28.6v0.2c0 8.5 2.4 15.2 7.2 20 4.8 4.9 10.8 8.5 18 10.8 7.2 2.3 17.2 4.7 30 7.2 0.5 0.1 0.9 0.2 1.3 0.2 0.4 0.1 0.8 0.1 1.3 0.2 0.6 0.1 1.2 0.2 1.9 0.3 0.7 0.1 1.3 0.2 1.9 0.3 15 3.1 27.4 6.7 37.5 10.9 10 4.2 18.4 11 25.1 20.3s10.1 22.1 10.1 38.3v0.3c0 15.1-3.6 27.9-10.7 38.6-7.1 10.7-17.5 18.9-31 24.5-13.5 5.6-29.9 8.4-49 8.4-12.3 0.3-18.3 0.3-18.3 0.3z"
                fill="#ffffff"
                p-id="4854"
              ></path>
              <path
                id="c22be5"
                class="uFSgLbN"
                d="M476 744.8c-10.7 0-19-8.6-19-19.3v-77.3c0-10.7 8.3-19.3 19-19.3s19 8.6 19 19.3v77.3c0 10.6-8.3 19.3-19 19.3zM476 435.5c-10.7 0-19-8.6-19-19.3v-77.3c0-10.7 8.3-19.3 19-19.3s19 8.6 19 19.3v77.3c0 10.6-8.3 19.3-19 19.3z"
                fill="#ffffff"
                p-id="4855"
              ></path>
              <path
                id="ceeb06"
                class="uhSKTBa"
                d="M474.1 836c-170.6 0-309.3-138.8-309.3-309.3s138.8-309.3 309.3-309.3c170.6 0 309.3 138.8 309.3 309.3S644.7 836 474.1 836z m0-579.9c-149.2 0-270.6 121.4-270.6 270.6s121.4 270.6 270.6 270.6S744.8 676 744.8 526.7 623.3 256.1 474.1 256.1zM829 755.3c-3.3 0-6.6-0.8-9.6-2.6l-92.7-53.5c-9.3-5.3-12.4-17.2-7.1-26.4 5.3-9.3 17.2-12.4 26.4-7.1l92.7 53.5c9.3 5.3 12.4 17.2 7.1 26.4-3.6 6.2-10.1 9.7-16.8 9.7z"
                p-id="4856"
                fill="#ffffff"
              ></path>
            </svg>
          </template>
          <!-- v-if="cardItem.content != '-'" -->
          <div
            v-for="(cardItem, index) in FinancialData.data"
            :key="index"
            class="uUgMeVl"
          >
            <content_text
              id="c6d35e"
              :label="cardItem.label"
              contentAlign="space-between"
              class="label_item"
            >
              <!-- <template slot="icon">
                <div id="c0da10" :style="{ background: FinancialData.color }" class="u1ba97"></div>
              </template> -->

              <div id="gfe9e2" class="uAXSGHp" style="text-align: right">
                {{ cardItem.content }}
              </div>
            </content_text>
          </div>
        </rectcard>
        <rectcard id="c1a998" v-model="CreditData" class="uvIF6MS">
          <template id="c5ef83" class="uPk9pHe" slot="icon">
            <svg
              t="1728814190900"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="17871"
            >
              <path
                d="M550.912 874.666667h-298.666667a149.504 149.504 0 0 1-149.333333-149.333334V341.333333a149.504 149.504 0 0 1 149.333333-149.333333h554.666667a149.504 149.504 0 0 1 149.333333 149.333333v108.501334a21.333333 21.333333 0 0 1-42.666666 0V341.333333a106.794667 106.794667 0 0 0-106.666667-106.666666h-554.666667a106.794667 106.794667 0 0 0-106.666666 106.666666v384a106.794667 106.794667 0 0 0 106.666666 106.666667h298.666667a21.333333 21.333333 0 0 1 0 42.666667z"
                fill="#FFFFFF"
                p-id="17872"
              ></path>
              <path
                d="M922.965333 405.333333H209.578667a21.333333 21.333333 0 0 1 0-42.666666h713.386666a21.333333 21.333333 0 0 1 0 42.666666zM764.288 903.978667a21.333333 21.333333 0 0 1-7.210667-1.28l-16.341333-5.845334c-197.589333-71.125333-167.466667-318.634667-166.101333-329.130666l3.669333-29.269334a21.333333 21.333333 0 0 1 14.037333-17.493333l164.821334-58.453333a21.418667 21.418667 0 0 1 14.250666 0l164.906667 58.453333a21.333333 21.333333 0 0 1 14.08 17.493333l3.626667 29.44c1.28 10.538667 29.312 258.645333-166.229334 328.96l-16.213333 5.845334a21.077333 21.077333 0 0 1-7.253333 1.28z m-145.28-347.178667l-2.048 16.341333c-1.194667 9.258667-27.434667 223.957333 138.24 283.562667l9.088 3.285333 9.045333-3.285333c163.626667-58.794667 139.605333-273.749333 138.368-283.562667l-2.048-16.341333-145.365333-51.541333z"
                fill="#FFFFFF"
                p-id="17873"
              ></path>
              <path
                d="M746.154667 765.994667a21.333333 21.333333 0 0 1-16.469334-7.808l-48.298666-59.008a21.333333 21.333333 0 0 1 32.981333-27.050667l31.786667 38.826667 67.968-83.029334a21.333333 21.333333 0 1 1 33.024 26.965334l-84.48 103.253333a21.248 21.248 0 0 1-16.512 7.850667z"
                fill="#FFFFFF"
                p-id="17874"
              ></path>
            </svg>
          </template>
          <!-- v-if="cardItem.content != '-'" -->
          <div
            v-for="(cardItem, index) in CreditData.data"
            :key="index"
            class="uUgMeVl"
          >
            <content_text
              id="ce60c5"
              :label="cardItem.label"
              contentAlign="space-between"
              class="label_item"
            >
              <!-- <template slot="icon">
                <div id="c2cbcd" :style="{ background: CreditData.color }" class="u1ba97"></div>
              </template> -->

              <div id="gfe9e2" class="uAXSGHp" style="text-align: right">
                {{ cardItem.content }}
              </div>
            </content_text>
          </div>
        </rectcard>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
// interfaceCode
//importStart

import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import { mapGetters } from "vuex";
//importEnd

export default {
  name: "",
  props: {
    companyBaseRoute: {
      type: Object,
      default: () => JSON.parse(localStorage.getItem("CompanyBase")),
    },
  },
  watch: {
    // 解决国际化不更新问题
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getCompanyBase();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    companyBaseRoute: {
      handler(newVal, oldVal) {
        // this.getCompanyBase
        this.companyBase = newVal;
        console.log(` this.companyBase`, this.companyBase);

        this.getCompanyBase();
        // 在这里可以执行其他操作，比如更新状态等
      },
      immediate: true, // 组件创建时立即执行一次
    },
  },
  computed: {
    LegalData() {
      return {
        color: "#1290C9",
        title: this.$t("Snapshot.LegalStatus"),
        data: [],
        textColor: "",
        status: "",
      };
    },

    CurrentData() {
      return {
        color: "#1290C9",
        title: this.$t("Snapshot.CurrentOpperations"),
        textColor: "",
        status: "",
        data: [],
      };
    },
    // FinancialData
    FinancialData() {
      return {
        color: "#1290C9",
        title: this.$t("Snapshot.Performance"),
        textColor: "",
        status: "",
        data: [],
      };
    },
    // CreditData
    CreditData() {
      return {
        color: "#1290C9",
        title: this.$t("Snapshot.CreditOpinion"),
        textColor: "",
        status: "",
        data: [],
      };
    },

    ...mapGetters({
      lang: "app/lang",
    }),
  },
  mounted() {
    this.$emit("UpdatamarkTotalList", []);
  },
  components: {
    gui_card,
    rectcard,
    content_text,
    ReLogin,
  },

  data() {
    return {
      reLoginVis: false,
      hideshow: false,
      companyBase: null,
      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  methods: {
    houershow(val) {
      this.hideshow = val;
    },
    getCompanyBase() {
      this.LegalData.textColor = this.companyBase?.legalStatus?.color;
      this.LegalData.status = this.companyBase?.legalStatus?.status;
      this.CurrentData.textColor = this.companyBase?.current?.color;
      this.CurrentData.status = this.companyBase?.current?.status;
      this.FinancialData.textColor = this.companyBase?.financialStatus?.color;
      this.FinancialData.status = this.companyBase?.financialStatus?.status;
      this.CreditData.textColor = this.companyBase?.creditRatings?.color;
      this.CreditData.status = this.companyBase?.creditRatings?.status;
      // this.companyBaseRoute == null? this.companyBase =JSON.parse(localStorage.getItem("CompanyBase")) :this.companyBase= this.companyBaseRoute;
      (this.LegalData.data = [
        {
          label: this.$t("Snapshot.CoID"),
          content: this.companyBase?.legalStatus?.id,
        },
        {
          label: this.$t("Snapshot.CompanyType"),
          content: this.companyBase?.legalStatus?.companyType,
        },
        {
          label: this.$t("Snapshot.RegistrationDate"),
          content: this.companyBase?.legalStatus?.registerDate,
        },

        {
          label: this.$t("Snapshot.RegistrationStatus"),
          content: this.companyBase?.legalStatus?.registerStatus,
        },
        {
          label: this.$t("Snapshot.Listed"),
          content: this.companyBase?.legalStatus?.listed,
        },
      ]),
        (this.CurrentData.data = [
          {
            label: this.$t("Snapshot.IndustryCode"),
            content: this.companyBase?.current?.industryCode,
          },
          {
            label: this.$t("Snapshot.BusinessActivities"),
            content: this.companyBase?.current?.industryDesc,
          },
          {
            label: this.$t("Snapshot.NoofEmployees"),
            content: this.companyBase?.current?.employee,
          },
          {
            label: this.$t("Snapshot.NoofShareholders"),
            content: this.companyBase?.current?.shareholds,
          },
          {
            label: this.$t("Snapshot.Management"),
            content: this.companyBase?.current?.managementStatus,
          },
        ]),
        (this.FinancialData.data = [
          {
            label: this.$t("Snapshot.Revenue"),
            content: this.companyBase?.financialStatus?.revenue,
          },

          {
            label: this.$t("Snapshot.Assets"),
            content: this.companyBase?.financialStatus?.asset,
          },
          {
            label: this.$t("Snapshot.ProfitLoss"),
            content: this.companyBase?.financialStatus?.financialStatus,
          },
          {
            label: this.$t("Snapshot.Growth"),
            content: this.companyBase?.financialStatus?.growth,
          },
          {
            label: this.$t("Snapshot.Competitiveness"),
            content: this.companyBase?.financialStatus?.competitiveness,
          },
        ]),
        (this.CreditData.data = [
          {
            label: this.$t("Snapshot.CreditRating"),
            content: this.companyBase?.creditRatings?.creditRating,
          },
          {
            label: this.$t("Snapshot.CreditScore"),
            content: this.companyBase?.creditRatings?.creditScore,
          },
          {
            label: this.$t("Snapshot.ESGRating"),
            content: this.companyBase?.creditRatings?.ratingESG,
          },
          {
            label: this.$t("Snapshot.Solvency"),
            content: this.companyBase?.creditRatings?.solvency,
          },
          {
            label: this.$t("Snapshot.Sanctions"),
            content: this.companyBase?.creditRatings?.sanctions,
          },
        ]);
      // this.companyBaseRoute == null? this.companyBase =JSON.parse(localStorage.getItem("CompanyBase")) :this.companyBase= this.companyBaseRoute;
    },
    setid(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },
  },
};
</script>
<style>
.uPdtqFl {
  display: flex;
  height: 620px;
  padding-top: 60px;
  padding-left: 40px;
  padding-right: 40px;
  background: #ffffff;
  justify-content: space-around;
  align-items: flex-start;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  opacity: 1;
}

.ud85c3 {
  padding-left: 80px;
}

.u9916e {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  height: auto;
}

.u4b926 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 30px;
  /* height: 2.14285714rem; */
  /* width: 2.93em; */
}

.u3eb5e {
  width: 150px;
  height: auto;
  margin-left: 20px;
  font-size: 20px;
  line-height: 34px;
  font-family: "Arial Bold";
  color: #1a2332;
  overflow-wrap: break-word;
  word-break: keep-all;
  white-space: normal;
}

.u61a08 {
  display: flex;
  align-items: flex-start;
  height: auto;
  max-width: 650px;
  min-height: 30px;
  font-size: 20px;
  line-height: 34px;
  color: #29445d;
}

.u110de {
  display: flex;
  align-items: center;
}

.u40641 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 32px;
  border-width: 1px;
  margin-right: 5px;
}

.ufde6c {
  font-size: 20px;
  line-height: 34px;
  color: #29445d;
}

/* .uc879f {
  width: 86px;
} */

.u4a559 {
  height: 30px;
  font-size: 20px;
  line-height: 34px;
  color: #1290c9;
  text-decoration: underline;
}

.udd14e {
  display: flex;
  justify-content: space-around;
  width: 100%;
  position: absolute;
  top: 560px;
  padding-right: 20px;
  padding-left: 20px;
}

.uvIF6MS {
  width: 0;
  flex: auto;
  margin-top: 50px;
  /* margin-bottom: 1.42rem; */
}

.u1ba97 {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.uAXSGHp {
  max-width: 50%;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  color: #666666;
  display: -webkit-box;
  text-align: right;
  /* 使用弹性盒子布局 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 2;
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.uAXSGHpshow {
  font-size: 16px;
  max-width: 226px;
  text-align: right;
}

.uab2Spu:hover .uAXSGHp {
  -webkit-line-clamp: auto !important;
  /* 限制为两行 */
}

#g4579f .icon {
  width: 28px;
}

/* edit */
.uUgMeVl {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  line-height: 32px;
}

.label_item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  line-height: 32px;
  margin-bottom: 22px;
}

.ua367f {
  justify-content: flex-start;
}

/* @media screen and (max-width: 1441px) {


.u3eb5e,.u61a08 {
  font-size: 1.45714285714286rem;
}
} */

#g9cd74 .icon {
  width: 32px;
  height: 32px;
}

#g9cd74 .secondIcon {
  width: 28px;
  height: 28px;
}

#g9cd74 .thirdIcon {
  width: 44px;
  height: 44px;
}

.udd14e > rectcard .u1dc85,
.udd14e > .uvIF6MS .u1dc85 {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.udd14e > rectcard .ua367f,
.udd14e > .uvIF6MS .ua367f {
  margin-top: auto;
}

.udd14e {
  display: flex;
  align-items: stretch;
  gap: 14px;
  box-sizing: border-box;
}

.udd14e > rectcard,
.udd14e > .uvIF6MS {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  box-sizing: border-box;
  min-width: 0;
}

.udd14e .u1dc85,
.udd14e .u1e6ea {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.udd14e .ua367f,
.udd14e .uUgMeVl {
  margin-top: auto;
}

.layout_cont {
  height: 100%;
}

@media screen and (max-width: 1920px) {
  .uPdtqFl {
    height: 640px;
    padding-top: 45px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .ud85c3 {
    padding-left: 60px;
  }

  .u9916e {
    margin-bottom: 10px;
    min-height: 50px;
  }

  .u4b926 {
    margin-right: 22px;
  }

  .u3eb5e {
    width: 120px;
    margin-left: 14px;
    font-size: 16px;
    line-height: 24px;
  }

  .u61a08 {
    max-width: 490px;
    min-height: auto;
    font-size: 16px;
    line-height: 24px;
  }

  .u40641 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 24px;
    margin-right: 4px;
    border-width: 1px;
  }

  .ufde6c {
    font-size: 16px;
    line-height: 24px;
  }

  /* .uc879f {
    width: 64px;
  } */

  .u4a559 {
    height: auto;
    font-size: 16px;
    line-height: 22px;
  }

  .udd14e {
    top: 500px;
    padding-right: 15px;
    padding-left: 15px;
    margin-top: 0;
  }

  .uvIF6MS {
    margin-top: 38px;
  }

  .u1ba97 {
    width: 9px;
    height: 9px;
  }

  .uAXSGHp {
    font-size: 16px;
    line-height: 20px;
  }

  .uAXSGHpshow {
    font-size: 14px;
    max-width: 170px;
  }

  #g4579f .icon {
    width: 28px;
  }

  /* edit */
  .uUgMeVl {
    margin-bottom: 10px;
    line-height: 24px;
  }

  .label_item {
    line-height: 24px;
    margin-bottom: 14px;
  }

  #g9cd74 .icon {
    width: 24px;
    height: 24px;
  }

  #g9cd74 .secondIcon {
    width: 22px;
    height: 22px;
  }

  #g9cd74 .thirdIcon {
    width: 32px;
    height: 32px;
  }

  .udd14e {
    gap: 10px;
  }
}

@media screen and (max-width: 1439px) {
  .uPdtqFl {
    height: 580px;
    padding-top: 40px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .ud85c3 {
    padding-left: 54px;
  }

  .u9916e {
    margin-bottom: 10px;
    min-height: 40px;
  }

  .u4b926 {
    margin-right: 20px;
  }

  .u3eb5e {
    width: 106px;
    margin-left: 14px;
    font-size: 14px;
    line-height: 22px;
  }

  .u61a08 {
    max-width: 436px;
    font-size: 14px;
    line-height: 22px;
  }

  .u40641 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 22px;
    margin-right: 3px;
  }

  .ufde6c {
    font-size: 14px;
    line-height: 22px;
  }

  /* .uc879f {
    width: 58px;
  } */

  .u4a559 {
    height: auto;
    font-size: 14px;
    line-height: 20px;
  }

  .udd14e {
    top: 430px;
    padding-right: 12px;
    padding-left: 12px;
    margin-top: 0;
  }

  .uvIF6MS {
    margin-top: 34px;
  }

  .u1ba97 {
    width: 8px;
    height: 8px;
  }

  .uAXSGHp {
    font-size: 14px;
    line-height: 16px;
  }

  .uAXSGHpshow {
    font-size: 12px;
    max-width: 150px;
  }

  #g4579f .icon {
    width: 18px;
  }

  .uUgMeVl {
    line-height: 22px;
  }

  .label_item {
    line-height: 22px;
    margin-bottom: 14px;
  }

  #g9cd74 .icon {
    width: 22px;
    height: 22px;
  }

  #g9cd74 .secondIcon {
    width: 18px;
    height: 18px;
  }

  #g9cd74 .thirdIcon {
    width: 30px;
    height: 30px;
  }
  .udd14e {
    gap: 9px;
  }
}
</style>
